// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartImpersonationMutationVariables = Types.Exact<{
  actsAsUserId: Types.Scalars['ID']['input'];
}>;


export type StartImpersonationMutation = { __typename?: 'Mutation', startImpersonation?: any | null };

export type StopImpersonationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StopImpersonationMutation = { __typename?: 'Mutation', stopImpersonation?: any | null };


export const StartImpersonationDocument = gql`
    mutation StartImpersonation($actsAsUserId: ID!) {
  startImpersonation(actsAsUserId: $actsAsUserId)
}
    `;
export type StartImpersonationMutationFn = Apollo.MutationFunction<StartImpersonationMutation, StartImpersonationMutationVariables>;

/**
 * __useStartImpersonationMutation__
 *
 * To run a mutation, you first call `useStartImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImpersonationMutation, { data, loading, error }] = useStartImpersonationMutation({
 *   variables: {
 *      actsAsUserId: // value for 'actsAsUserId'
 *   },
 * });
 */
export function useStartImpersonationMutation(baseOptions?: Apollo.MutationHookOptions<StartImpersonationMutation, StartImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartImpersonationMutation, StartImpersonationMutationVariables>(StartImpersonationDocument, options);
      }
export type StartImpersonationMutationHookResult = ReturnType<typeof useStartImpersonationMutation>;
export type StartImpersonationMutationResult = Apollo.MutationResult<StartImpersonationMutation>;
export type StartImpersonationMutationOptions = Apollo.BaseMutationOptions<StartImpersonationMutation, StartImpersonationMutationVariables>;
export const StopImpersonationDocument = gql`
    mutation StopImpersonation {
  stopImpersonation
}
    `;
export type StopImpersonationMutationFn = Apollo.MutationFunction<StopImpersonationMutation, StopImpersonationMutationVariables>;

/**
 * __useStopImpersonationMutation__
 *
 * To run a mutation, you first call `useStopImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopImpersonationMutation, { data, loading, error }] = useStopImpersonationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopImpersonationMutation(baseOptions?: Apollo.MutationHookOptions<StopImpersonationMutation, StopImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopImpersonationMutation, StopImpersonationMutationVariables>(StopImpersonationDocument, options);
      }
export type StopImpersonationMutationHookResult = ReturnType<typeof useStopImpersonationMutation>;
export type StopImpersonationMutationResult = Apollo.MutationResult<StopImpersonationMutation>;
export type StopImpersonationMutationOptions = Apollo.BaseMutationOptions<StopImpersonationMutation, StopImpersonationMutationVariables>;